import React from "react";
import "./Footer.css";

export default function Footer() {
  return (
    <div className="footer">
      <a
        href="https://github.com/rohithgoje21/AI-platforms"
        target="_blank"
        rel="noopener noreferrer"
      >
        Made by Rohith Goje
      </a>
    </div>
  );
}
